<template>
    <div>
      <div id="listloader" v-if="isLoading">
            <div class="listloader"></div>
        </div>
      <b-card v-if="this.usertype=='1'">
        <b-list-group flush>
          <b-list-group-item v-for="(item, index) in hubCount" :key="index">
            <b-button
              variant="primary"
              class="w-100 text-left"
              @click="toggleCollapse(index,item.hub_id)"
            >
            <b-row class="text-center">
               <b-col sm="3" title="Hub ID">#{{item.hub_id}}
               </b-col>
               <b-col sm="6" title="Hub Title">Hub Title : {{item.hub_title}}
               </b-col>
            </b-row>
            </b-button>
            <b-collapse  @hide="hubDrawerClose" :visible="activeCollapse === index" :id="'collapse-' + index">
              <b-card>
                <b-card-text v-if="vehicleListLength">
                  <daily_trip_vehicle :nestedItems="vehicleList" />
                </b-card-text>
                <b-card-text v-else>
                  <span>No Records Found</span>
                </b-card-text>
              </b-card>
            </b-collapse>
          </b-list-group-item>
        </b-list-group>
      </b-card>
      <b-card v-else>
        <!-- {{  vehicleListLength}} -->
        <div v-if="vehicleListLength">
          <daily_trip_vehicle :nestedItems="vehicleList" />
        </div>
        <div v-else>
            <b-row>
              <b-col sm="12" class="text-center">
                <span>No Records Found</span>
              </b-col>
            </b-row>
        </div>
      </b-card>
    </div>
  </template>
  
  <script>
  import CONSTANTS from '@/utils/constants'
  import Utils from '@/utils'
  import Vue from 'vue'
  import daily_trip_vehicle from "./daily_trip_vehicle.vue"; // Import the nested drawer component
  import spinner from './Loader/spinner.vue';
  
  export default {
    components: {
      daily_trip_vehicle,
      spinner,
    },
    data() {
      return {
        activeCollapse: null,
        hubCount :[],
        hubListCount:0,
        selecthubid:'',
        vehicleList:[],
        vehicleListLength:0,
        vehicleListCount:0,
        vehicleListTimeout:null,
        apiHubCallAllowed:null,
        hubListTimeout:null,
        apiVehicleCallAllowed:false,
        isLoading:false,
        hubcount_length:0,
        accessBody:[],
        isReadOnly:false,
      };
    },
    beforeDestroy () {
      if (this.usertype==1) {
         this.apiHubCallAllowed=false;
         this.hubListTimeout=null;
       }
       else{
         this.apiVehicleCallAllowed=false
         this.vehicleListTimeout=null
       }
    },
    created() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.usertype = userInfo.user_type
      
      if (userInfo.user_type==1) {
        this.activeCollapse = null;
       const storedActiveCollapse = localStorage.getItem("activeCollapse");
        if (storedActiveCollapse) {
            this.activeCollapse = storedActiveCollapse;
        }
        this.hubDashboardcount();
       
      }
      else{
        console.log("else")
        this.vehicleListing();
        this.startVehicleApiCall();
      }
      this.accessBody = userInfo.body;
        console.log("--------->>>>>>>>>>",userInfo.body)
        this.ischeckbodyvalidation();
    //   this.hubDashboardcount();
    },
    methods: {
      ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=='Daily Trip' && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='Daily Trip' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
      toggleCollapse(index,hub_id) {
        // Toggle the collapse based on the current state
        this.activeCollapse = this.activeCollapse === index ? null : index;
        // Update localStorage
        localStorage.setItem("activeCollapse", this.activeCollapse);
        
        this.vehicleListing(hub_id);
        this.startVehicleApiCall();
      },

      hubDashboardcount : function(){
        this.isLoading=true;
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const obj={
          sysusermasterid:`${userInfo.sysusermasterid}`,
          usertype:`${userInfo.user_type}`
        } 
        // console.log("obj",obj)
        this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getallhubtohubcountNew`,obj)
          .then(result => {
            this.isLoading=false;
            if (result.body.returnmsg === "Successful") {
            this.hubCount=result.body.returnvalue;
            this.hubcount_length=result.body.returnvalue.length;
            this.startHubApiCall();
            }else{
                this.hubCount=[];
                this.hubcount_length=0;
            }
          }).catch(ex => {
            console.log("error", ex);
        });
      },
      vehicleListing(value){  

      // console.log(value)   
      this.selecthubid=value;
      this.isLoading=true;
      console.log("value",value);
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        console.log("UserInfo",userInfo);
        // if (userInfo.user_type==1) {
          let Obj={
            sysusermasterid:`${userInfo.sysusermasterid}`,
            user_type:`${userInfo.user_type}`,
            hub_id :userInfo.user_type=='1'?this.selecthubid:userInfo.hub_id,
          }    
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getDistinctVehicleListFromTemporaryTripDetails`,Obj).then((result)=>{
          this.isLoading=false;
            if (result.body.returnmsg === 'Successful') {
              this.vehicleList=result.body.returnvalue;
              this.vehicleListLength=result.body.returnvalue.length;
              console.log("this.vehicleListLength",this.vehicleListLength);
            }else{
              this.vehicleList=[];
              this.vehicleListLength=0;
            }
        })
      },

      startHubApiCall(){
       this.apiHubCallAllowed = true; // Allow API calls on this route
       this.ApiToGetHubListCount()  
    },
    startVehicleApiCall(){
      console.log("Innn");
       this.apiVehicleCallAllowed = true; // Allow API calls on this route
       this.ApiToGetVehicleListCount();   
    },
    ApiToGetHubListCount(){
      var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const obj={
          sysusermasterid:`${userInfo.sysusermasterid}`,
        } 
        // console.log("obj",obj)
        this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getApiToGetHubListCountNew`,obj)
          .then(result => {
            this.isLoading=false;
            if (result.body.returnmsg === "Successful") {
            this.hubListCount=result.body.returnvalue[0].hub_count;
            
            if (this.apiHubCallAllowed) {
                // Schedule the next API call with a recursive call after 15 seconds
                this.hubListTimeout = setTimeout(() => {
                  this.ApiToGetHubListCount();
                }, 25000); // 15 seconds
              }
              console.log("this.hubcount_length@@@@@@",this.hubcount_length,this.hubListCount)
              if(this.hubcount_length!=parseInt(this.hubListCount) && this.hubcount_length !=0){
                  this.hubDashboardcount();
              }
            }else{
                this.hubListCount=0;
            }
          }).catch(ex => {
            console.log("error", ex);
        });
    },
    ApiToGetVehicleListCount(){
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const obj={
          hub_id :userInfo.user_type=='1'?this.selecthubid:userInfo.hub_id,
        } 
        console.log("obj",obj)
        this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/ApiToGetVehicleListCount`,obj)
          .then(result => {
            this.isLoading=false;
            if (result.body.returnmsg === "Successful") {
            this.vehicleListCount=result.body.returnvalue[0].vehicle_count;
            
            if (this.apiVehicleCallAllowed) {
                // Schedule the next API call with a recursive call after 15 seconds
                this.vehicleListTimeout = setTimeout(() => {
                  this.ApiToGetVehicleListCount();
                }, 20000); // 20 seconds
              }
              // console.log("this.vehicleListLength@@@@@@@@@@",this.vehicleListLength,this.vehicleListCount);
              if(this.vehicleListLength!=parseInt(this.vehicleListCount) && this.vehicleListLength !=0){
                // console.log("Innn Vehicle Listing");
                  this.vehicleListing(this.selecthubid);
              }
            }else{
                this.vehicleListCount=0;
            }
          }).catch(ex => {
            console.log("error", ex);
        });
      },
      hubDrawerClose(){
        this.apiVehicleCallAllowed=false
         this.vehicleListTimeout=null
      }
    },
  };
  </script>
  
  <style scoped>
  /* Add additional styling if needed */
  </style>
  